
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSReturnLaborGrid extends Serenity.EntityGrid<POSReturnLaborRow, any> {
        protected getColumnsKey() { return 'Retail.POSReturnLabor'; }
        protected getIdProperty() { return POSReturnLaborRow.idProperty; }
        protected getInsertPermission() { return POSReturnLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return POSReturnLaborRow.localTextPrefix; }
        protected getService() { return POSReturnLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}